import { PhoneIcon } from "../molecules/phone"
import { TimeIcon } from "../molecules/time"
import { MarkIcon } from "../molecules/mark"
import contactsPicture from "../../../common/assets/images/contactsPicture.png";
import contactsMap from "../../../common/assets/images/contactsMap.png";

import "../styles/ContactsBlock.css"
import { $SiteColors } from "../../../common/config/company-atts";

export const ContactsBlock = () => {
  return (
    <section className="page__content page__content_overflow">
      <h1 className="page__title" style={{color:$SiteColors.getState().titleColor}}>Связаться с УК</h1>
      <div className="page__data" style={{backgroundColor:$SiteColors.getState().cardBackgroundColor}}>
        <div className="contacts">
          <div className="contacts__left-side">
            <div className="contacts__container">
              <p className="contacts__text contacts__text_bold">
                Контактная информация
              </p>
              <p className="contacts__text">ООО “КРК”</p>
              <div className="contacts__text-icon">
                <PhoneIcon />{" "}
                <p className="contacts__text">
                  8 (800) 355 56-37, +7 (391) 219 35-75
                </p>
              </div>
              <div className="contacts__text-icon">
                <TimeIcon />
                <p className="contacts__text">
                  Пн - пт с 8:30 до 17:30 , обед 12:30 - 13:30.
                </p>
              </div>
              <div className="contacts__text-icon">
                <MarkIcon />
                <p className="contacts__text">
                  г. Красноярск, ул. Новосибирская, 9А
                </p>
              </div>
            </div>
            <div className="contacts__container">
              <p className="contacts__text contacts__text_bold">
                Написать обращение
              </p>
              <form className="contacts__request">
                <input
                  placeholder="Выберите категорию"
                  className="contacts__input"
                />
                <textarea
                  placeholder="Не нашли ответ на свой вопрос? Задайте его!"
                  className="contacts__input contacts__input_textarea"
                />
                <button className="contacts__button">
                  Отправить
                </button>
              </form>
            </div>
          </div>
          <div className="contacts__right-side">
            <img src={contactsPicture} alt="Картинка контактов" className="contacts__picture" />
            <img src={contactsMap} alt="Карта" className="contacts__picture" />
          </div>
        </div>
      </div>
    </section>
  )
}
